import React from 'react';
import PropTypes from 'prop-types';

const InputLabel = (props) => {
  const requiredFieldChar =
    (props.requiredFieldIndicatorStyle.style === "star") ?
      "*" :
      (props.requiredFieldIndicatorStyle.style === "dot") ?
        "•" :
        "";

  const potentialRequiredFieldIndicator = <abbr title="This field is required">{requiredFieldChar}</abbr>;

  const requiredFieldIndicator = (props.required && props.isEditable) ?
    potentialRequiredFieldIndicator :
    null;

  let label = null;
  if (props.label) {
    label = (props.requiredFieldIndicatorStyle.position === "before") ?
      <React.Fragment>{requiredFieldIndicator}<label htmlFor={props.htmlFor}>{props.label}</label></React.Fragment> :
      <React.Fragment><label htmlFor={props.htmlFor}>{props.label}</label>{requiredFieldIndicator}</React.Fragment>;
  }

  let legend = null;
  if ((props.legend || props.required) && label == null) {
    legend = (props.requiredFieldIndicatorStyle.position === "before") ?
      <legend>{requiredFieldIndicator}{props.legend}</legend> :
      <legend>{props.legend}{requiredFieldIndicator}</legend>;
  }

  return <React.Fragment>{legend}{label}</React.Fragment>;
}

InputLabel.defaultProps = {
  isEditable: true,
  required: false,        // is this a required field?
  requiredFieldIndicatorStyle: {style: "star", position: "before"}
};

InputLabel.propTypes = {
  label: PropTypes.string,
  legend: PropTypes.string,
  htmlFor: PropTypes.string,
  isEditable: PropTypes.bool,
  required: PropTypes.bool,
  requiredFieldIndicatorStyle: PropTypes.shape({
    style: PropTypes.string,      // either "star", "dot" or "none"
    position: PropTypes.string    // either "before" or "after"
  })
}

export default InputLabel;
